










import Vue from "vue";
import { Component } from "vue-property-decorator";
import isPC from '@/lib/isPC'

@Component
export default class App extends Vue {
  isCodeVisible = false

  mounted() {
    this.isCodeVisible = isPC() ? true : false
  }
}
